import { call, put, takeLatest } from "redux-saga/effects";
import { types } from "../action-types";
import { searchTalentsApi } from "../../API/API";

function* searchTalentsSaga(params) {
  try {
    const response = yield call(() => searchTalentsApi(params));
    yield put({ type: types.SEARCH_TALENTS_SUCCESS, payload: response.data?.data?.data || [] });
  } catch (error) {
    yield put({ type: types.SEARCH_TALENTS_FAILURE, error });
  }
}

export function* watchSearchTalentsSaga() {
  yield takeLatest(types.SEARCH_TALENTS_INIT, searchTalentsSaga);
}
